import styled from 'styled-components';
import { HistoryGraphContainer } from '../../styles';
import { colors } from 'styles/colors';
import { primaryScrollbar } from 'styles/scrollbar';

export const HistoryContainer = styled(HistoryGraphContainer)`
  gap: 20px;
  height: 372px;
  max-width: 712px;

  @media (max-width: 1024px) {
    height: 418px;
  }
`;

export const GraphContainer = styled.div<{ comingSoon?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  flex: 1;
  gap: 8px;

  ${({ comingSoon }) => (comingSoon ? `
    filter: blur(2px);
    opacity: 0.6;
    pointer-events: none;
  ` : '')}

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

export const LegendContent = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 4px;

  & > span {
    font-weight: 400;
    font-size: 12px;
    color: ${colors.text['main-900']};
    line-height: 150%;
  }
`;

export const LegendContainer = styled.div`
  display: grid;
  gap: 16px;
  align-items: start;
  justify-items: start;

  grid-template-columns: repeat(4, auto);

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, auto);
    justify-items: center;

    & > div:nth-child(4) {
      grid-column-start: 2;
    }
  }
`;

export const GraphInnerContainer = styled.div<{ containerId: string }>`
  height: 260px;
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: center;

  .tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }

  ${primaryScrollbar}

  @media (max-width: 1024px) {
    overflow-x: auto;
    #${({ containerId }) => containerId} {
      padding-bottom: 20px;
    }
`;

export const TooltipContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const TooltipRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  & > span {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${colors.text['main-900']};
  }

  & > span:nth-of-type(2) {
    margin-left: auto;
  }
`;
